<template>

  <div class="px-2">
    
    <div class="d-flex justify-content-end mb-1 align-items-end">
      <h5>Resultados: {{table.totalRows}}</h5>
    </div>


    <b-table 
      v-if="!loadingTable"
      striped responsive
      :per-page="table.perPage" 
      :items="itemsLabsAux"
      :fields="fieldsLabAux" 
      
    >

      <template #cell(codigoOrion)="data">

        <div v-if="data.item.codigoOrion" class="d-flex align-items-center">
          {{ data.item.codigoOrion }}
          <b-button 
            size="sm" 
            variant="warning" 
            class="ml-1 p-0" 
            style="width: 25px; height: 25px"
            title="Actualizar Codigo"
            @click="onShowModalCodigo(data.item.token)"
          >
            <i class="fa-solid fa-rotate"/>
          </b-button>
        </div>

        <div
          v-else-if="String(data.item.estadoLaboratorio) === '2'"
          class="d-flex justify-content-center"
        >
          <b-button 
            size="sm" 
            variant="primary"
            @click="onShowModalCodigo(data.item.token)"
          >
            Agregar código Orion
          </b-button>
        </div>

        <div v-else class="text-center text-muted">-</div>
      </template>

      <template #cell(estadoLaboratorio)="data">
        <div>
          {{
            data.item.estadoLaboratorio
              ? {
                '1': 'Creado',
                '2': 'Programado',
                '3': 'Vinculado',
                '4': 'Validado'
              }[data.item.estadoLaboratorio] || data.item.estadoLaboratorio
              : 'Creado'
          }}
        </div>
        <div 
          style="text-align: center;" 
          :class="data.item.tipoCobertura.descripcion !== 'PARTICULAR' ? data.item.colorArchivoMsp : '' "
        >
          {{ data.item.tipoCobertura.descripcion !== 'PARTICULAR'
            ? `msp subido ${data.item.nCoberturasSubidas}/${data.item.nTitulares}` 
            : `` }}
        </div>
      </template>

      <template #cell(tipoCobertura.descripcion)="data">
        <span v-if="data.item.tipoCobertura.descripcion === 'PARTICULAR'" class="text-primary">
          {{
            data.item.tipoCobertura.descripcion
          }}
        </span>
        <span v-else>
            {{
              data.item.tipoCobertura.descripcion
            }}
        </span>
      </template>
        

      <template #cell(acciones)="data">

        <div class="d-flex">

          <b-button
            v-if="showActaLaboratorio"
            size="sm"
            title="Acta Laboratorio"
            @click="downloadActaLaboratorio(data.item.idCita)"
          >
            <i class="fa-solid fa-i"/>
          </b-button>

          <b-button 
            :variant="data.item.estadoLaboratorio === '1' || !data.item.estadoLaboratorio ? 'primary' : 'warning'" 
            size="sm"
            @click="showModalFecha(data.item.token)">
            <i class="fas fa-calendar" style="color: white"/>
          </b-button>
          
          <b-button
            size="sm" 
            variant="info"
            @click="onViewDetails(data.item.token)"
            title="Ver detalles"
          >

            <font-awesome-icon 
              icon="magnifying-glass" 
              style="color: white;" 
            />

          </b-button>

          <b-button
            v-if="data.item.estadoLaboratorio === '2'"
            size="sm"
            variant="primary"
            @click="onLinkOrion(data.item.token)"
            title="Enviar a Orion"
          >
            <i class="fa-solid fa-project-diagram"/>
          </b-button>

          <b-button
            v-if="data.item.estadoLaboratorio === '3'"
            size="sm"
            variant="info"
            class="d-flex align-items-center"
            @click="onShowModalResultados(data.item.token)"
            title="Subir resultado"
          >
            <i class="fa-solid fa-flask" style="color: white" />
            <span class="ml-1 text-white">PDF</span>
          </b-button>

          <b-button
            v-if="showButtonLoadMSP && data.item.tipoCobertura.descripcion !== 'PARTICULAR'" 
            variant="info"
            size="sm"
            @click="onShowModalMSP(data.item.token)"
          >
            <i class="fas fa-arrow-up" style="color: white" />
          </b-button>

          <b-button 
            v-if="data.item.estadoLaboratorio == '4'" 
            size="sm" 
            @click="downloadReportId(data.item.urlInforme)"
          >
            <i class="fas fa-id-card" style="margin-right: 10px;" title="Informe" />
          </b-button>

          <b-button 
            v-if="canViewForm13(data.item.laboratorios, data.item.estadoLaboratorio)" 
            size="sm" 
            @click="navigateToQuery('13alab', data.item.token)"
            variant="primary"
            title="Formulario 13"
          >
            13
          </b-button>

        </div>
      </template>

    </b-table>

    <b-skeleton-wrapper v-if="loadingTable">
      <b-skeleton 
        v-for="i in 15"
        :key="i"
        width="100%" 
        height="50px"
      />
    </b-skeleton-wrapper>

    <b-pagination 
      v-if="itemsLabsAux.length > 0" 
      v-model="table.page"
      :total-rows="table.totalRows" 
      :per-page="table.perPage"
      first-number 
      :small="true" 
      class="mb-0 mx-auto" 
      align="center"
      prev-class="prev-item" 
      next-class="next-item" 
      @change="onChangePage"
    >
      <template #prev-text>
        <feather-icon icon="ChevronLeftIcon" size="18" />
      </template>
      <template #next-text>
        <feather-icon icon="ChevronRightIcon" size="18" />
      </template>
    </b-pagination>

    <CodigoOrionAux/>
    <ViewDetailsAux/>
    <ModalProgramarFecha/>
    <ModalResultadosLabAux/>

    <!-- <ModalLoadMSP 
      :tipolab="'2'"
      :isVisible.sync="showModalLoadMSP" 
      :dataLaboratorio="dataToUpdateFileMsp"
    /> -->

    <ModalViewFile 
      v-show="fileToView" 
      :urlFile="fileToView" 
      v-model="isModalFileVisible" 
    />

    <Formulario013aLab :isLabAux="true"/>
    <ModalLoadMSP/>
  </div>
  
  
</template>

<script>
import { comprobarRoles, getEstablecimientoLS, getIdDoctorLS } from '@/shared/helpers';
import { ROLES } from '@/shared/constants';
import actions   from '@/assets/utils/utils';
import { ModalViewFile }      from '@/shared/components';
import Formulario013aLab      from "@/views/procesoclinico/components/Formularios/Formulario013aLab.vue";
import { ModalLoadMSP }       from '../ModalLoadMSP.vue';
import { labAuxiliarService } from '../../services';
import  ViewDetailsAux        from '../LabAuxiliares/ViewDetailsAux.vue';
import CodigoOrionAux         from '../LabAuxiliares/CodigoOrionAux.vue';
import ModalProgramarFecha    from '../LabAuxiliares/ModalProgramarFecha.vue';
import ModalResultadosLabAux  from '../LabAuxiliares/ModalResultadosLabAux.vue';
import axios from 'axios';
import rutas from '@/assets/utils/rutas.json';

export default {

  name: 'TableLabAux',

  props: {
    filters: {
      type: Object,
      required: false
    },
    descargarExcelAux: Boolean
  },


  components: {
    CodigoOrionAux,
    ViewDetailsAux,
    ModalViewFile,
    ModalLoadMSP,
    ModalProgramarFecha,
    ModalResultadosLabAux,
    Formulario013aLab
  },


  created() {

    this.getDataTable();
  },

  data() {
    return {
      itemsLabsAux:       [],
      loadingTable:       false,
      showModalLoadMSP:   false,
      fileToView:         null,
      isModalFileVisible: false,
      dataToUpdateFileMsp:null,
      table: {
        page: 1,
        pageSize: 5,
        totalRows: 0
      },

      fieldsLabAux: [
        { key: 'paciente',                  label: 'Paciente',         sortable: true, thClass: 'text-center' },
        { key: 'tipoCobertura.descripcion', label: 'Cobertura',        sortable: true, thClass: 'text-center' },
        { key: 'codigoOrden',               label: 'Codigo Medinet',   sortable: true, thClass: 'text-center' },
        { key: 'codigoOrion',               label: 'Codigo Orion',     sortable: true, thClass: 'text-center' },
        { key: 'fechaCita',                 label: 'Fecha Atencion',   sortable: true, thClass: 'text-center' },
        { key: 'fechaProgramada',           label: 'Fecha Programada', sortable: true, thClass: 'text-center' },
        { key: 'doctor',                    label: 'Doctor',           sortable: true, thClass: 'text-center' },
        { key: 'especialidad',              label: 'Especialidad',     sortable: true, thClass: 'text-center' },
        { key: 'estadoLaboratorio',         label: 'Estado/MSP',           sortable: true, thClass: 'text-center' },
        { key: 'acciones',                  label: 'acciones',         sortable: true, thClass: 'text-center', tdClass: 'text-right' },
      ],

    }
  },



  methods: {
    async getDataTable(excel){
      this.loadingTable = true;
      const establecimientoUser = getEstablecimientoLS();
      // const establecimiento = this.isAdmin ? '0' : establecimientoUser.id;
      const establecimiento =  establecimientoUser.id;

      const idDoctor = getIdDoctorLS();
      const viewAll = comprobarRoles([ROLES.JEFE_MEDICO, ROLES.AUX_LABORATORIO, ROLES.LABORATORIO, ROLES.AGENDAMIENTO]);

      const params = {
        modalidad        : this.filters.modalidad    || '1',
        search           : this.filters.search       || '',
        estadoLaboratorio: this.filters.estadoLaboratorio,
        cobertura        : this.filters.cobertura,
        especialidad     : this.filters.especialidad || '',
        doctor           : viewAll ? '' : idDoctor,
        establecimiento,
        fechaDesde       : this.filters.fechaDesde   || '',
        fechaHasta       : this.filters.fechaHasta   || '',
        page             : this.table.currentPage,
        pageSize         : this.table.perPage,
        excel            : excel,
        tipoFecha        : this.filters.tipoFecha     || '',
        observaciones    : this.filters.observaciones || ''
      }
      

      await this.getLabsAux(params);
      this.descargandoBase = false
      this.$emit('descarga-completada');
    },

    async downloadActaLaboratorio(idCita) {
      if (!idCita) {
        this.$swal({
          title: "Acta no disponible",
          text: "No se pudo identificar la cita asociada al laboratorio.",
          icon: "warning",
          confirmButtonColor: "#089599",
        });
        return;
      }

      const query = `                
       query qrGetDocumentActa($idCita: String!, $servicio : String) {
          getDocumentActa(idCita: $idCita, servicio: $servicio) {
            status
            message
            citaPdf
            cita{
              id
              fechaCita
              horaCita
              paciente{
                persona{
                  primerNombre
                  primerApellido
                  identificacion
                }
              }
            }
          }
        }
      `;

      const variables = {
        idCita,
        servicio: 'LABORATORIO'
      };

      try {
        const response = await axios.post(rutas.axios + 'api', { query, variables });
        if (response.status === 200) {
          const pdfBase64 = response.data.data.getDocumentActa.citaPdf;
          actions.cargarArchivos(pdfBase64, `acta_${idCita}.pdf`, "data:application/pdf;base64");
        }
      } catch (error) {
        console.error("Error al descargar el acta de laboratorio:", error);
        this.$swal({
          title: "Error",
          text: "No se pudo descargar el acta del laboratorio.",
          icon: "error",
          confirmButtonColor: "#089599",
        });
      }
    },

    downloadReportId(downloadUrl) {
      this.fileToView = downloadUrl;
      this.isModalFileVisible = true;
    },

    async getLabsAux(params){
      const responseLab = await labAuxiliarService.getAll(params);

      if(!responseLab || !responseLab.data) return;

      if (responseLab.labFile) {
        const data = responseLab.labFile
        actions.cargarArchivos(data, "LaboratoriosAuxiliares.xlsx", "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64")
      }

      this.itemsLabsAux    = await this.mapperAux(responseLab.data);
      this.table.totalRows = responseLab.total;
      this.loadingTable    = false;
    },



    mapperAux(dataLab){
      const mappedData = dataLab.map(lab => {
        const dataCita = lab.consultamedica?.cita || lab.atencionMedica?.cita || {};
        const dataPaciente = dataCita?.paciente?.persona || {};

        const titularesString = (dataCita?.detallescitaSet && dataCita.detallescitaSet.length > 0) 
          ? dataCita.detallescitaSet[0].detallesTitulares 
          : "";
        const titulares  = titularesString ? JSON.parse(titularesString) : [];
        const nTitulares = (titulares?.length || 0) + 1;
        const coberturaPaciente = lab.urlMspCalificacion ? 1 : 0;
        const coberturaTitular1 = lab.urlMspCalificacion1 ? 1 : 0;
        const coberturaTitular2 = lab.urlMspCalificacion2 ? 1 : 0;
        const nCoberturasSubidas = coberturaPaciente + coberturaTitular1 + coberturaTitular2;
        
        return {
          id              : lab.id,
          token           : lab.token,
          idCita          : dataCita?.id,
          fechaCita       : dataCita?.fechaCita,
          doctor          : `${dataCita?.doctor?.idPersona?.primerApellido || ''} ${dataCita?.doctor?.idPersona?.primerNombre || ''}`.trim(),
          establecimiento : dataCita?.establecimiento?.Descripcion,
          especialidad    : dataCita?.doctor?.especialidad?.descripcion,
          paciente        : `${dataPaciente.identificacion || ''} - ${dataPaciente.primerApellido || ''} ${dataPaciente.primerNombre || ''}`.trim(),
          pacienteId      : dataCita?.paciente?.id,
          // examen       : `(${lab.laboratorios.codigo}) ${lab.laboratorio.descripcion}`,
          laboratorios    : lab.laboratorios ? JSON.parse(lab.laboratorios) : [],
          codigoOrden     : lab.codigoOrden,
          urlInforme      : lab.urlInforme,
          fechaResultado  : lab.fechaResultado,
          codigoOrion     : lab.codigoOrion,
          esHomologado    : lab.estadoHomologado,
          estadoLaboratorio: lab.estadoLaboratorio,
          fechaProgramada : lab.fechaProgramada,
          nTitulares          : nTitulares,
          nCoberturasSubidas  : nCoberturasSubidas,
          colorArchivoMsp     : nTitulares === nCoberturasSubidas ? 'light-success' : 'light-secondary',
          tipoCobertura   : dataCita.cobSeleccionada
        }
      });

      return mappedData
    },


    onChangePage(page){
      this.table.currentPage = page;
      this.getDataTable();
    },

    onShowModalCodigo(tokenAux) {
      this.navigateToQuery("code", tokenAux);
    },


    showModalFecha(tokenAux) {
      this.navigateToQuery("setDate", tokenAux);
    },


    onViewDetails(tokenAux) {
      this.navigateToQuery("view_aux", tokenAux);
    },


    navigateToQuery(queryParam, valueQuery) {
      try {
        this.$router.push({
          path: this.$route.path,
          query: {
            ...this.$route.query,
            [queryParam]: valueQuery,
          },
        });
      } catch (error) {
        console.error("Error en la navegación:", error);
      }
    },

    onShowModalMSP(tokenlab) {
      this.navigateToQuery("msp", tokenlab);
    },

    onShowModalResultados(tokenAux) {
      this.navigateToQuery("result", tokenAux);
    },
    
    // onLoadMSP(dataItem) {
    //   this.showModalLoadMSP = true;
    //   this.dataToUpdateFileMsp = dataItem;
    // },



    async onLinkOrion(Token) {
      if (Token) {
        // Mostrar Swal de confirmación
        const confirmation = await this.$swal({
          title: "¿Estás seguro?",
          text: "¿Deseas enviar la orden a Orion?",
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Sí, enviar",
          cancelButtonText: "Cancelar",
        });

        // Si el usuario no confirma, salir de la función
        if (!confirmation.isConfirmed) {
          return;
        }

        const params = {
          token: Token || '',
        };

        const responseLab = await labAuxiliarService.sendOrion(params);

        if (!responseLab || responseLab.status !== 'success') {
          this.$swal("No Enviado!", "La orden no ha sido enviada", "error");
          return;
        }

        const resumen = responseLab.json?.data;
        if (!resumen) {
          this.$swal("Error!", "No se pudo obtener resumen de la orden", "error");
          return;
        }

        const htmlResumen = `
          <div style="text-align: left;">
            <p><strong>Número de Orden Orion:</strong> ${resumen.numero_orden}</p>
            <p><strong>Fecha Orden Orion:</strong> ${resumen.fecha_orden}</p>
          </div>
        `;

        await this.$swal({
          title: "Orden enviada exitosamente",
          html: htmlResumen,
          icon: "success",
          confirmButtonText: "Aceptar",
        });
      }
    },


    canViewForm13(laboratorios, estadoLaboratorio){

      const codigoCitologiaVaginal = '390001';

      if (!laboratorios || laboratorios.length === 0) return false;

      const existeCitologia = laboratorios.some(lab => lab.codigo === codigoCitologiaVaginal);
      const estadoValido = parseInt(estadoLaboratorio) > 1;

      return estadoValido && existeCitologia;
    },
  },

  computed:{

    showButtonLoadMSP(){
      return comprobarRoles([ROLES.JEFE_MEDICO, ROLES.AGENDAMIENTO, ROLES.AUX_LABORATORIO, ROLES.LABORATORIO]);
    },
    showActaLaboratorio() {
      return comprobarRoles([
        ROLES.ADMISION,
        ROLES.JEFE_MEDICO,
        ROLES.ADMINISTRADOR,
        ROLES.AGENDAMIENTO,
        ROLES.AUX_LABORATORIO,
        ROLES.LABORATORIO,
      ]);
    },
  },

  watch: {
    filters: {
      deep: true,
      handler() {
        this.getDataTable();
      }
    },

    descargarExcelAux(newVal) {
      if (newVal) {
        this.getDataTable('1');
      }
    }   
    
  }
}
</script>
<style lang="scss" scoped>
.light-success {
    background-color: #d4edda;
    color: #155724;
    padding: 5px;
    border-radius: 5px;
    text-align: center;
  }
  
  .light-secondary {
    background-color: #f8d7da;
    color: #721c24;
    padding: 5px;
    border-radius: 5px;
    text-align: center;
  }
</style>
